import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from '@/modules/collections/lateQuotas/store/lateQuotaSlice/initialState.ts'
import { QuotaDTO } from '@/modules/collections/lateQuotas/types/Quota.ts'

const lateQuotaSlice = createSlice({
  name: 'lateQuota',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setLoadingAction: (state, action: PayloadAction<boolean>) => {
      state.isLoadingAction = action.payload
    },
    setLateQuotas: (state, action: PayloadAction<QuotaDTO[]>) => {
      state.lateQuotas = action.payload
    },
    setEditId: (state, action: PayloadAction<string | null>) => {
      state.editId = action.payload
    },
    setFilters: (state, action: PayloadAction<string>) => {
      state.filters = action.payload
    },
    reset: () => initialState
  }
})

export const lateQuotaActions = lateQuotaSlice.actions
export const { reducer: lateQuotaReducer } = lateQuotaSlice
